import * as tslib_1 from "tslib";
import deleteConversationItemParts from './deleteConversationItemParts';
import parseConversationResponse from './parseConversationResponse';
import createEmptyConversationItemParts from '../utils/createEmptyConversationItemParts';
import getErrorResponseCode from '../utils/getErrorResponseCode';
import isActionSourcePrefetch from '../utils/isActionSourcePrefetch';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action, select } from 'satcheljs/lib/legacy';
import { getConversationItemsService, conversationCache, } from 'owa-mail-store';
var assign = require('object-assign');
export var INITIAL_MAX_ITEMS_TO_RETURN = 20;
export var LOAD_MORE_INCREMENT = 10;
export var MAX_ITEMS_ALLOWED_TO_RETRIEVE = 100;
var pendingRequestPromises = {};
function getConversationSortOrderFromSettings() {
    var userConfiguration = getUserConfiguration();
    var sortOrderFromOptions = userConfiguration.UserOptions.ConversationSortOrderReact;
    var conversationSortOrder;
    if (sortOrderFromOptions !== undefined && typeof sortOrderFromOptions == 'string') {
        // Convert string to enum
        conversationSortOrder = sortOrderFromOptions;
    }
    else {
        conversationSortOrder = sortOrderFromOptions;
    }
    return conversationSortOrder;
}
function setPendingRequestState(conversationToLoad, actionSource) {
    if (!conversationToLoad.pendingRequestState) {
        conversationToLoad.pendingRequestState = {
            shouldUseEmptySyncState: !conversationToLoad.syncState,
        };
    }
    else {
        // If one of pending requests needs to use empty syncState, keep shouldUseEmptySyncState to be true.
        conversationToLoad.pendingRequestState.shouldUseEmptySyncState =
            conversationToLoad.pendingRequestState.shouldUseEmptySyncState ||
                !conversationToLoad.syncState;
    }
    conversationToLoad.pendingRequestState.actionSource = actionSource;
}
var processGetConversationItemsResponse = action('processGetConversationItemsResponse')(function processGetConversationItemsResponse(conversationSortOrder, conversationId, responseMessage, conversations) {
    parseConversationResponse(responseMessage, conversationSortOrder, conversationId);
    var loadedConversation = conversations.get(conversationId.Id);
    loadedConversation.loadingState.isLoading = false;
    delete pendingRequestPromises[conversationId.Id];
    if (loadedConversation.pendingRequestState) {
        // Issue the pending GCI if has one
        loadConversation(conversationId, loadedConversation.pendingRequestState.actionSource);
    }
});
var loadConversation = action('loadConversation')(select({
    conversations: function () { return conversationCache; },
})(function loadConversation(conversationIdToLoad, actionSource, topActionDatapoint, state) {
    var promiseToReturn = Promise.resolve();
    var conversationSortOrder = getConversationSortOrderFromSettings();
    var conversationRawIdToLoad = conversationIdToLoad.Id;
    var conversationToLoad = state.conversations.get(conversationRawIdToLoad);
    // If cached conversationSortOrder is different from userOption, delete the cache
    if (conversationToLoad &&
        conversationToLoad.conversationSortOrder != conversationSortOrder) {
        deleteConversationItemParts(conversationRawIdToLoad);
        conversationToLoad = null;
    }
    // If conversation has no cache or previous cache failed, create an empty one
    if (!conversationToLoad || conversationToLoad.loadingState.hasLoadFailed) {
        conversationToLoad = createEmptyConversationItemParts(conversationIdToLoad, conversationSortOrder);
    }
    // Save empty conversationItemPart, or touch conversationCache to reduce the possibility that the conversation got purged from cache
    state.conversations.add(conversationRawIdToLoad, conversationToLoad);
    conversationToLoad = state.conversations.get(conversationRawIdToLoad);
    // For each new coming GCI request, we "queue" it as a pending request to guarantee only one ongoing GCI per conversation.
    // But we don't really queue requests, instead, we just set/update pending request status based on new coming GCI requests.
    setPendingRequestState(conversationToLoad, actionSource);
    var requestStartTime;
    if (topActionDatapoint) {
        requestStartTime = topActionDatapoint.addCheckmark('request_start');
    }
    if (!conversationToLoad.loadingState.isLoading) {
        var shouldUseEmptySyncState = conversationToLoad.pendingRequestState.shouldUseEmptySyncState;
        conversationToLoad.loadingState.isLoading = true;
        // Clear pending GCI state
        conversationToLoad.pendingRequestState = null;
        var mailboxInfo = conversationToLoad.conversationId.mailboxInfo;
        var shouldReturnModernConversationItems = mailboxInfo.returnModernConversationItems;
        // Add action source to the request header 'X-OWA-ActionSource' for diagnostic
        var options = {};
        assign(options, mailboxInfo && mailboxInfo.requestOptions);
        if (options && options.headers) {
            var headers = new Headers(options.headers);
            headers.set('X-OWA-ActionSource', actionSource);
            options.headers = headers;
        }
        promiseToReturn = getConversationItemsService(conversationToLoad.conversationId, conversationToLoad.syncState, conversationToLoad.maxItemsToReturn, conversationSortOrder, shouldUseEmptySyncState, shouldReturnModernConversationItems, options)
            .then(function (responseMessage) {
            // Add the request time as the custom data.
            if (topActionDatapoint) {
                var requestEndTime = topActionDatapoint.addCheckmark('request_end');
                topActionDatapoint.addCustomData({
                    requestTime: requestEndTime - requestStartTime,
                });
            }
            processGetConversationItemsResponse(conversationSortOrder, conversationIdToLoad, responseMessage, state.conversations);
            var _a = tslib_1.__read(getErrorResponseCode(responseMessage), 2), errorResponseCode = _a[0], stackTrace = _a[1];
            if (errorResponseCode) {
                return Promise.reject(new Error("ErrorResponseCode=" + errorResponseCode + ", StackTrace=" + stackTrace));
            }
            else {
                return Promise.resolve();
            }
        })
            .catch(function (error) {
            // If owa-service throws an error, we want to catch it here process as a null responseMessage
            processGetConversationItemsResponse(conversationSortOrder, conversationIdToLoad, null /* responseMessage */, state.conversations);
            // Add the action source to the error message
            error.message += ", ActionSource=" + actionSource;
            // If the action source is not prefetch, reject the error.
            if (!isActionSourcePrefetch(actionSource)) {
                return Promise.reject(error);
            }
            else {
                return Promise.resolve();
            }
        });
        // Cache the promise in case future calls come in waiting for the same conversation.
        pendingRequestPromises[conversationRawIdToLoad] = promiseToReturn;
    }
    else if (pendingRequestPromises[conversationRawIdToLoad]) {
        // If we have a cached promise for this conversation, return that for waiting callers.
        // This is particularly important for double-click to open a popout. When the user double-clicks in the listView,
        // a single-click will also trigger and start loading the conversation. We want to return that promise, so
        // the double-click popout code can also wait on it.
        promiseToReturn = pendingRequestPromises[conversationRawIdToLoad];
        // If the request is in pending request table, add it in custom data.
        if (topActionDatapoint) {
            topActionDatapoint.addCustomData({ pendingRequest: true });
        }
    }
    return promiseToReturn;
}));
export { loadConversation };
//# sourceMappingURL=loadConversation.js.map